
import React from "react";
import { cn } from "@/lib/utils";

export interface BrandTextProps {
  gradient?: boolean;
  muted?: boolean;
  size?: "xs" | "sm" | "base" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
  weight?: "normal" | "medium" | "semibold" | "bold";
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  children?: React.ReactNode;
  [key: string]: any; // For additional props
}

/**
 * Text component that follows the VirtuStaff brand guidelines
 */
export const BrandText = React.forwardRef<HTMLElement, BrandTextProps>(
  ({ 
    gradient = false, 
    muted = false, 
    size = "base", 
    weight = "normal", 
    as: Component = "p", 
    className, 
    children, 
    ...props 
  }, ref) => {
    const sizeClasses = {
      xs: "text-xs",
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg",
      xl: "text-xl",
      "2xl": "text-2xl",
      "3xl": "text-3xl",
      "4xl": "text-4xl",
    };

    const weightClasses = {
      normal: "font-normal",
      medium: "font-medium",
      semibold: "font-semibold",
      bold: "font-bold",
    };

    return React.createElement(
      Component,
      {
        ref,
        className: cn(
          sizeClasses[size],
          weightClasses[weight],
          gradient && "bg-gradient-to-r from-brand to-blue-500 bg-clip-text text-transparent",
          muted && "text-muted-foreground",
          className
        ),
        ...props
      },
      children
    );
  }
);

BrandText.displayName = "BrandText";
